<template>
  <div style="display: inline-block; vertical-align: middle; margin: 0 5px">
    <slot />
  </div>
</template>
